import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { IPowerBIService } from "services/PowerBIService";
import { PowerBIReportModel } from "services/api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { RootState } from "setup/redux/RootReducer";

type PowerBIReportState = {
  ReportEmbedData: PowerBIReportModel | undefined;
  Loading: boolean;
  DataLoaded: boolean;
  CurrentReportID: number | undefined;
};

const initialState: PowerBIReportState = {
  ReportEmbedData: undefined,
  Loading: false,
  DataLoaded: false,
  CurrentReportID: undefined,
};

export const PowerBIReportsSlice = createSlice({
  name: "PowerBIReports",
  initialState,
  reducers: {
    setCurrentReportID: (state, action) => {
      state.CurrentReportID = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getReport.pending, (state) => {
        state.Loading = true;
      })
      .addCase(getReport.fulfilled, (state, action) => {
        state.ReportEmbedData = action.payload;
        state.Loading = false;
        state.DataLoaded = true;
      })
      .addCase(getReport.rejected, (state) => {
        state.Loading = false;
      });
  },
});

export const getReport = createAsyncThunk<PowerBIReportModel, number>(
  "PowerBIReports/GetReport",
  async (reportID: number) => {
    const powerBIService = container.get<IPowerBIService>(SERVICE_TYPES.PowerBIService);
    return await powerBIService.getReport(reportID);
  }
);

export const { setCurrentReportID } = PowerBIReportsSlice.actions;

export const selectReportEmbedData = (state: RootState) => state.powerBIReports.ReportEmbedData;
export const selectLoadingData = (state: RootState) => state.powerBIReports.Loading;
export const selectDataLoaded = (state: RootState) => state.powerBIReports.DataLoaded;
export const selectCurrentReportID = (state: RootState) => state.powerBIReports.CurrentReportID;

export default PowerBIReportsSlice.reducer;
